<template>
  <div id="data-view">
    <dv-full-screen-container>
      <br>
      <top-header/>

      <div class="main-content">

        <div class="main-top">
          <div class="left-content">
            <ScwlCycleLine/>
            <br/>
            <br/>
            <ScwlContractScrollBoard/>
            <ScwlWaybillMonthChart/>
          </div>
          <div class="center-content">
            <ScwlmapVehicle/>
            <br>
          </div>
          <div class="right-content">
            <ScwlOrderScrollBoard/>
            <br/>
            <br/>
<!--            <ScwlOrderMonthChart/>-->
            <ScwlWaybillMonthChartOther/>
          </div>
        </div>

        <div class="main-bottom">
          <div class="bottom-left">
            <ScwlWaybillScrollBoard/>
          </div>
          <div class="bottom-right">
            <ScwlWaybillDayChart/>
          </div>

        </div>


      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
  import topHeader from './topHeader'

  import ScwlContractScrollBoard from './ScwlContractScrollBoard.vue'
  import ScwlOrderScrollBoard from './ScwlOrderScrollBoard.vue'
  import ScwlWaybillScrollBoard from './ScwlWaybillScrollBoard.vue'
  import ScwlmapVehicle from './ScwlmapVehicle.vue'
  import ScwlCycleLine from './ScwlCycleLine.vue'
  import ScwlWaybillMonthChart from './ScwlWaybillMonthChart.vue'
  import ScwlWaybillMonthChartOther from './ScwlWaybillMonthChartOther.vue'
  import ScwlWaybillDayChart from './ScwlWaybillDayChart.vue'
  import ScwlOrderMonthChart from './ScwlOrderMonthChart.vue'


  import { bigScreen } from '@/api/statistics.js'

  export default {
    name: 'DataView',
    components: {
      topHeader,
      ScwlContractScrollBoard,
      ScwlOrderScrollBoard,
      ScwlWaybillScrollBoard,
      ScwlWaybillDayChart,
      ScwlmapVehicle,
      ScwlCycleLine,
      ScwlWaybillMonthChart,
      ScwlWaybillMonthChartOther,
      ScwlOrderMonthChart
    },
    data () {
      return {
        timer: null
      }
    },
    created () {
      this.bigScreen()

      if (this.timer != null) {
        clearInterval(this.timer)
      }

      this.timer = setInterval(() => {
        this.bigScreen()
      }, 1000 * 60 * 10)
    }, mounted () {
      this.$nextTick(() => {

      })

    },
    beforeDestroy () {
      if (this.timer != null) {
        clearInterval(this.timer)
      }
    },
    methods: {
      bigScreen () {
        bigScreen().then(res => {
          this.$store.commit('bigScreenData/SET_DATA_OBJ', res.data)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_DRIVER_COUNT', res.data.driverInfoCount)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_VEHICLE_COUNT', res.data.vehicleCount)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_WAYBILL_COUNT', res.data.waybillCount)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_CLIENT_CONTRACT_COUNT', res.data.clientContractCount)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_ORDER_COUNT', res.data.orderCount)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_WAYBILL_SCROLL_LIST', res.data.waybillScrollList)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_LOCATION_VEHICLE', res.data.locationVehicle)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_WAYBILL_LIST', res.data.waybillList)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_WAYBILL_MONTH_LIST', res.data.waybillMonthList)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_WAYBILL_DAY_LIST', res.data.waybillDayList)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_ORDER_LIST', res.data.orderList)
          this.$store.commit('bigScreenData/SET_DATA_OBJ_ORDER_MONTH_LIST', res.data.orderMonthList)
        })
      }
    }
  }
</script>

<style lang="less">
  #data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;

    #dv-full-screen-container {
      background-image: url('./img/bg.png');
      background-size: 100% 100%;
      box-shadow: 0 0 3px blue;
      display: flex;
      flex-direction: column;
    }

    .main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .main-top {
      width: 100%;
      height: 70%;
      display: flex;
    }

    .left-content, .right-content {
      width: 23.6%;
      margin-right: 1%;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      box-sizing: border-box;
    }

    .center-content {
      width: 50%;
      height: 100%;
      flex-direction: column;
      box-sizing: border-box;
      display: flex;
      flex-grow: 0;
    }


    .main-bottom {
      margin-bottom: 40px;
      width: 100%;
      height: 30%;
      display: flex;
      justify-content: space-around;
    }


    .bottom-left, .bottom-right {
      width: 49.6%;
      height: 100%;
      display: flex;
    }

    /*.block-left-right-content {*/
    /*  flex: 1;*/
    /*  display: flex;*/
    /*  margin-top: 20px;*/
    /*}*/

    /*.block-top-bottom-content {*/
    /*  flex: 1;*/
    /*  display: flex;*/
    /*  flex-direction: column;*/
    /*  box-sizing: border-box;*/
    /*  padding-left: 20px;*/
    /*}*/

    /*.block-top-content {*/
    /*  height: 100%;*/
    /*  display: flex;*/
    /*  flex-grow: 0;*/
    /*  box-sizing: border-box;*/
    /*  padding-bottom: 20px;*/
    /*}*/
  }
</style>
